const { registerBlockType } = wp.blocks;
const { RichText } = wp.blockEditor;

// Title black big
registerBlockType('fura/title-black-big', {
    // Built in attributes
    title: 'Title Black big',
    block: 'Title block with left black line',
    category: 'layout',

    // custom attributes
    attributes: {
        text: {
            type: 'string'
        }
    },

    // custom functions
    edit({ attributes, setAttributes }) {
        function updateText(event) {
            setAttributes({
                text: event.target.value
            });
        }

        return (
            <div class="admin-title-black">
                <div class="admin-title-black__label"></div>
                <input 
                    class="admin-title-black__input" 
                    value={attributes.text} 
                    onChange={updateText} 
                    type="text" 
                />
            </div>
        );
    },

    // built-in functions
    save({ attributes }) {
        return (
            <div>
                <div class="fura-block row">
                    <div class="col-1 col-lg-4">
                        <div class="dark-block"></div>
                    </div>
                    <div class="col-11 col-lg-8">
                        <h2 class="title-2">{ attributes.text }</h2>
                    </div>
                </div>
            </div>
        );
    }
})

// Title black medium
registerBlockType('fura/title-black-medium', {
    // Built in attributes
    title: 'Title Black medium',
    block: 'Title block with left black line',
    category: 'layout',

    // custom attributes
    attributes: {
        text: {
            type: 'string'
        }
    },

    // custom functions
    edit({ attributes, setAttributes }) {
        function updateText(event) {
            setAttributes({
                text: event.target.value
            });
        }

        return (
            <div class="admin-title-black">
                <div class="admin-title-black__label"></div>
                <input class="admin-title-black__input" value={attributes.text} onChange={updateText} type="text" />
            </div>
        );
    },

    // built-in functions
    save({ attributes }) {
        return (
            <div>
                <div class="fura-block row">
                    <div class="col-1 col-lg-4">
                        <div class="dark-block"></div>
                    </div>
                    <div class="col-11 col-lg-8">
                        <h3 class="title-3">{ attributes.text }</h3>
                    </div>
                </div>
            </div>
        );
    }
})

// Lateral text content
registerBlockType('fura/lateral-text-content', {
    // Built in attributes
    title: 'Text Lateral',
    block: 'Text lateral with left padding',
    category: 'layout',

    // custom attributes
    attributes: {
        text: {
            type: 'string',
            source: 'html',
            selector: 'p'
        }
    },

    // custom functions
    edit({ attributes, setAttributes }) {
        function updateText(newText) {
            setAttributes({
                text: newText
            });
        }
        
        return ([
            <div>
                <div class="fura-block row">
                    <div class="col-1 col-lg-4">
                    </div>
                    <div class="col-11 col-lg-8">
                    <RichText 
                        key="editable"
                        tagName="p"
                        placholder="text.."
                        value={attributes.text}
                        onChange={updateText}
                    />
                    </div>
                </div>
            </div>
        ]);
    },

    // built-in functions
    save({ attributes }) {
        return (
            <div>
                <div class="fura-block row">
                    <div class="col-1 col-lg-4">
                    </div>
                    <div class="col-11 col-lg-8">
                        <RichText.Content
                            className="text-left-content"
                            tagName="p"
                            value={attributes.text}
                        />
                    </div>
                </div>
            </div>
        );
    }
})


registerBlockType('fura/person-big', {
    // Built in attributes
    title: 'Person Big',
    block: 'Person Big',
    category: 'layout',

    // custom attributes
    attributes: {
        name: {
            type: 'string',
            source: 'html',
            selector: 'h3'
        },
        text: {
            type: 'string',
            source: 'html',
            selector: 'p'
        },
    },

    // custom functions
    edit({ attributes, setAttributes }) {
        function updateName(newName) {
            setAttributes({
                name: newName
            });
        }

        function updateText(newText) {
            setAttributes({
                text: newText
            });
        }
        
        return ([
            <div>
                <RichText 
                    key="editable"
                    tagName="h3"
                    placholder="name.."
                    value={attributes.name}
                    onChange={updateName}
                />
                 <RichText 
                    key="editable"
                    tagName="p"
                    placholder="text & image"
                    value={attributes.text}
                    onChange={updateText}
                />
            </div>
        ]);
    },

    // built-in functions
    save({ attributes }) {
        return (
            <div>
                <div class="person-big">
                    <RichText.Content
                        className="title-person-big"
                        tagName="h3"
                        value={attributes.name}
                    />
                    <RichText.Content
                        className="text-person-big"
                        tagName="p"
                        value={attributes.text}
                    />
                </div>
            </div>
        );
    }
})

registerBlockType('fura/person-medium', {
    // Built in attributes
    title: 'Person medium',
    block: 'Person medium',
    category: 'layout',

    // custom attributes
    attributes: {
        image: {
            type: 'string',
            source: 'html',
            selector: 'h4'
        },
        name: {
            type: 'string',
            source: 'html',
            selector: 'h3'
        },
        text: {
            type: 'string',
            source: 'html',
            selector: 'p'
        },
    },

    // custom functions
    edit({ attributes, setAttributes }) {
        function updateImage(newImage) {
            setAttributes({
                image: newImage
            });
        }

        function updateName(newName) {
            setAttributes({
                name: newName
            });
        }

        function updateText(newText) {
            setAttributes({
                text: newText
            });
        }
        
        return ([
            <div>
                <RichText 
                    key="editable"
                    tagName="h4"
                    placholder="image"
                    value={attributes.image}
                    onChange={updateImage}
                />
                <RichText 
                    key="editable"
                    tagName="h3"
                    placholder="name.."
                    value={attributes.name}
                    onChange={updateName}
                />
                <RichText 
                    key="editable"
                    tagName="p"
                    placholder="text"
                    value={attributes.text}
                    onChange={updateText}
                />
            </div>
        ]);
    },

    // built-in functions
    save({ attributes }) {
        return (
            <div>
                <div class="person-medium clearfix">
                    <RichText.Content
                        className="image-person-medium"
                        tagName="h4"
                        value={attributes.image}
                    />
                    <RichText.Content
                        className="title-person-medium"
                        tagName="h3"
                        value={attributes.name}
                    />
                    <RichText.Content
                        className="text-person-medium"
                        tagName="p"
                        value={attributes.text}
                    />
                </div>
            </div>
        );
    }
})

registerBlockType('fura/person-small', {
    // Built in attributes
    title: 'Person small',
    block: 'Person small block',
    category: 'layout',

    // custom attributes
    attributes: {
        name: {
            type: 'string',
            source: 'html',
            selector: 'h3'
        },
        text: {
            type: 'string',
            source: 'html',
            selector: 'p'
        },
    },

    // custom functions
    edit({ attributes, setAttributes }) {

        function updateName(newName) {
            setAttributes({
                name: newName
            });
        }

        function updateText(newText) {
            setAttributes({
                text: newText
            });
        }
        
        return ([
            <div>
                <RichText 
                    key="editable"
                    tagName="h3"
                    placholder="name.."
                    value={attributes.name}
                    onChange={updateName}
                />
                 <RichText 
                    key="editable"
                    tagName="p"
                    placholder="text"
                    value={attributes.text}
                    onChange={updateText}
                />
            </div>
        ]);
    },

    // built-in functions
    save({ attributes }) {
        return (
            <div>
                <div class="person-small clearfix">
                    <RichText.Content
                        className="title-person-small"
                        tagName="h3"
                        value={attributes.name}
                    />
                    <RichText.Content
                        className="text-person-small"
                        tagName="p"
                        value={attributes.text}
                    />
                </div>
            </div>
        );
    }
})

registerBlockType('fura/download-element', {
    // Built in attributes
    title: 'Download Element',
    block: 'Block to download element',
    category: 'layout',

    // custom attributes
    attributes: {
        title: {
            type: 'string'
        },
        description: {
            type: 'string'
        },
        download: {
            type: 'string'
        }
    },

    // custom functions
    edit({ attributes, setAttributes }) {
        function updateTitle(event) {
            setAttributes({
                title: event.target.value
            });
        }

        function updateDescription(event) {
            setAttributes({
                description: event.target.value
            });
        }

        function updateDownload(event) {
            setAttributes({
                download: event.target.value
            });
        }

        return (
            <div>
                <input 
                    class="input-download-block"
                    value={attributes.title} 
                    onChange={updateTitle}
                    placeholder="title"
                    type="text" 
                />
                <input 
                    class="input-download-block"
                    value={attributes.description} 
                    onChange={updateDescription} 
                    placeholder="description"
                    type="text" 
                />
                <input 
                    class="input-download-block"
                    value={attributes.download} 
                    onChange={updateDownload}
                    placeholder="asset url"
                    type="text" 
                />
            </div>
        );
    },

    // built-in functions
    save({ attributes }) {
        return (
            <div>
                <div class="download-block">
                    <h3>{attributes.title}</h3>
                    <p>{attributes.description}</p>
                </div>
                <a class="download-btn" href={attributes.download} target="_blank" rel="noopener noreferrer">
                    Descargar
                </a>
            </div>
        );
    }
})